import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-setting-bank-form',
  templateUrl: './setting-bank-form.component.html',
  styleUrls: ['./setting-bank-form.component.scss']
})
export class SettingBankFormComponent {

  public data: any = {status: 1, show_at_frontend: 0};
  @ViewChild('f') f : NgForm

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.init(val)
      }
    })
  }

  async init(uuid) {
    this.data = await this.http.post('/admin/setting/bank/get', {uuid});
    // DB stores the usage flags as 1/0 — coerce to booleans for the checkboxes.
    this.data.use_deposit = Number(this.data.use_deposit) === 1;
    this.data.use_withdraw = Number(this.data.use_withdraw) === 1;
  }

  async submit() {
    await this.http.post("/admin/setting/bank/update", this.data);
    if (this.data.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-bank'])
      return;
    }
    await this.f.resetForm({status: 1, show_at_frontend: 0});
  }

}
